// == Description
//  This plugin displays an error message on a form element
//
// == Behaviour
//  when invoked, shows an error message (styled as a rails `flash`) for the given form element

(function ($) {
  "use strict";

  $.fn.flashError = function (message) {
    var $element = $(this);
    // we don't append the error message directly on the element that caused the error (might be a radio button or something),
    // but rather on its parent of class 'control'
    var parent = $element.closest('.control');

    parent.children('.error').remove();
    parent.append('<label class="error alert">' + message + '</label>');
  }
}(window.jQuery));
